import './Footer.css';
import schoolLogo from '../assets/logo/logo_phs.png';
import cambridgeLogo from '../assets/acc cambridge.webp';

function Footer({ onNavigate, hideAccreditation }) {
  const currentYear = new Date().getFullYear();

  const handleMenuClick = (e, slug) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(slug);
    }
  };

  const campuses = [
    {
      name: 'Campus 1',
      address: 'Jl. Pos Pengumben Lama No. 13, Srengseng, Kembangan, Jakarta Barat',
      mapsUrl: 'https://maps.app.goo.gl/TEkiMjRPHCw7pR4L6'
    },
    {
      name: 'Campus 2',
      address: 'Jl. Srengseng Raya No. 69, Srengseng, Kembangan, Jakarta Barat',
      mapsUrl: 'https://maps.app.goo.gl/TEkiMjRPHCw7pR4L6'
    }
  ];

  return (
    <footer className="footer">
      {/* Logo Row - Full Width */}
      <div className="footer-logo-row">
        <img src={schoolLogo} alt="Permata Harapan School" className="footer-logo" />
        <div className="footer-logo-text">
          <h3 className="footer-logo-title">Permata Harapan School</h3>
          <p className="footer-logo-subtitle">SCHOOL FOR LIFE</p>
        </div>
      </div>

      {/* Main Content - 4 Grid Layout */}
      <div className="footer-content">
        {/* Grid 1 (30%) - Title + Campus Info */}
        <div className="footer-grid-1">
          {/* Campus Info */}
          <div className="footer-campus-info">
            {campuses.map((campus, idx) => (
              <div key={idx} className="campus-block">
                <p className="campus-name">{campus.name}</p>
                <p className="campus-address">{campus.address}</p>
              </div>
            ))}
            <div className="footer-contact-info">
              <p className="contact-item">Tel: +62 21 555 1234</p>
              <p className="contact-item">WhatsApp: +62 812 3456 7890</p>
            </div>
          </div>
        </div>

        {/* Grid 2 (10%) - Empty Spacer */}
        <div className="footer-grid-2">
        </div>

        {/* Grid 3 (30%) - Menu Utama */}
        <div className="footer-grid-3">
          <h4 className="footer-column-title">MAIN MENU</h4>
          <nav className="footer-nav">
            <a href="#about-us" onClick={(e) => handleMenuClick(e, 'about-us')} className="footer-nav-link">About Us</a>
            <a href="#education-program" onClick={(e) => handleMenuClick(e, 'education-program')} className="footer-nav-link">Education Program</a>
            <a href="#admissions" onClick={(e) => handleMenuClick(e, 'admissions')} className="footer-nav-link">Admissions</a>
            <a href="#student-life" onClick={(e) => handleMenuClick(e, 'student-life')} className="footer-nav-link">Student Life</a>
            <a href="#facilities" onClick={(e) => handleMenuClick(e, 'facilities')} className="footer-nav-link">Facilities</a>
            <a href="#news-updates" onClick={(e) => handleMenuClick(e, 'news-updates')} className="footer-nav-link">News and Updates</a>
            <a href="#parents" onClick={(e) => handleMenuClick(e, 'parents')} className="footer-nav-link">Parents</a>
          </nav>
        </div>

        {/* Grid 4 (30%) - Campus Badges + Accreditation + Social Media */}
        <div className="footer-grid-4">
          <h4 className="footer-column-title">SCHOOL INFORMATION</h4>
          
          {/* Campus Badges */}
          <div className="footer-locations">
            {campuses.map((campus, idx) => (
              <a
                key={idx}
                href={campus.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="location-badge"
                title={`Buka ${campus.name} di Google Maps`}
              >
                {campus.name}
              </a>
            ))}
          </div>

          {/* Accreditation */}
          {!hideAccreditation && (
            <div className="footer-accreditation">
              <p className="accreditation-label">Terakreditasi oleh</p>
              <div className="accreditation-logo">
                <img src={cambridgeLogo} alt="Cambridge International" />
              </div>
            </div>
          )}

          {/* Social Media Icons */}
          <div className="footer-socials">
            <a href="https://instagram.com/permataharapan" target="_blank" rel="noopener noreferrer" className="social-icon" title="Instagram">
              <i className="fab fa-instagram" />
            </a>
            <a href="https://facebook.com/permataharapan" target="_blank" rel="noopener noreferrer" className="social-icon" title="Facebook">
              <i className="fab fa-facebook" />
            </a>
            <a href="https://youtube.com/permataharapan" target="_blank" rel="noopener noreferrer" className="social-icon" title="YouTube">
              <i className="fab fa-youtube" />
            </a>
            <a href="https://tiktok.com/@permataharapan" target="_blank" rel="noopener noreferrer" className="social-icon" title="TikTok">
              <i className="fab fa-tiktok" />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          ©{currentYear} Permata Harapan School. All Rights Reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;
